module.exports = __webpack_public_path__ + "static/media/report-error.c3ace606.svg";